import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { DEPRECATED_Typography } from "../../../../../components/DEPRECATED_Typography";
import { Icon } from "../../../../../components/Icon";
import Checkmark from "../../../../../icons/checkmark.svg";
import styles from "./CategoryFilterItem.module.scss";
export const CategoryFilterItem = ({ categoryKey, iconUrl, label, isActiveFilter, onFilterClick, }) => {
    const itemClasses = classNames(styles.item, {
        [styles.active]: isActiveFilter,
    });
    const handleSetActiveFilter = () => {
        onFilterClick(categoryKey);
    };
    return (_jsxs("li", { className: styles.wrapper, onClick: handleSetActiveFilter, children: [_jsxs("div", { "data-testid": "categoryFilterItem", className: itemClasses, children: [isActiveFilter && (_jsx("div", { "data-testid": "activeFilterIcon", className: styles.activeIcon, children: _jsx(Icon, { component: Checkmark, className: styles.checkMark, width: "10px" }) })), _jsx("img", { draggable: false, className: styles.image, alt: label, src: iconUrl })] }), _jsx(DEPRECATED_Typography, { type: "p3", color: "grey-5", children: label })] }));
};
//# sourceMappingURL=CategoryFilterItem.js.map